export default __webpack_public_path__ + "static/media/login-splash.91d2e9e2.jpg";